<template>
  <div class="page-wrapper">
    <GymFull :expanded="true" :gym="gym" />
  </div>
</template>

<script>
import GymFull from '@/components/molecules/GymFull.vue';
import { mapState } from 'vuex';
export default {
  components: {
    GymFull,
  },
  data() {
    return {
      hasGym: false,
    };
  },
  computed: {
    ...mapState(['gym']),
    // ...mapGetters(['hasGym'])
  },
  methods: {
    // ...mapActions(['findGymById']),
    // ...mapMutations(['storeGymId']),
    // async retrieveGym() {
    //   if (!this.hasGym) {
    //     this.storeGymId(this.$route.params.id)
    //     this.findGymById()
    //   }
    // }
  },
  // async mounted() {
  //   await this.retrieveGym();
  // }
};
</script>
